<template>
	<Row class="flex-align-center width-100">
		<SettingsManageUsersInfoAvatar class="avatar" :user="user" :size="size" />
		<Col class="flex-justify-center">
			<h5 class="user-name reg">{{ userFullName }}</h5>
			<h5 class="description-text reg">{{ userMail }}</h5>
		</Col>
	</Row>
</template>
<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { teamMemberByUserId } from '@/store/modules/account/getters';
import AppAvatarService from '@/components/common/AppAvatar/app-avatar-service.js';
import SettingsManageUsersInfoAvatar from '@/components/SettingsManageUsersInfoAvatar.vue';
export default {
	name: 'ComboboxUserItem',
	components: { SettingsManageUsersInfoAvatar },
	props: { item: { type: Object }, size: { type: Number, default: 35 } },
	computed: {
		...mapGettersShorthand({ teamMemberByUserId }),
		userId() {
			return this.item.user_id;
		},
		user() {
			return this.teamMemberByUserId(this.userId);
		},
		userFullName() {
			return AppAvatarService.getUserFullName(this.user);
		},
		userMail() {
			return this.user?.email;
		},
	},
};
</script>
<style scoped lang="scss">
.user-name {
	color: var(--primary-font-color);
}
.description-text {
	opacity: 0.5;
	color: #292829;
	font-weight: 300;
}
.avatar {
	margin-right: 10px;
}
</style>
